export default __webpack_public_path__ + "static/media/aircon-gray.dc67efc3.svg";